import { render, staticRenderFns } from "./MarqueeX.vue?vue&type=template&id=7c63b530&"
import script from "./MarqueeX.vue?vue&type=script&lang=js&"
export * from "./MarqueeX.vue?vue&type=script&lang=js&"
import style0 from "./MarqueeX.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports